
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import { FooterButton } from "../../common/footer/FooterButton";
import Header from "../../common/header/Header";
import TagSection from "./tag/TagSection";

export default function TagDetail() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const params = useParams();
	const tagId = params.tagId;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'برچسب', href: `/tag/${tagId}` },
	];
	const [tagTitle, setTagTitle] = useState('');

	useEffect(() => {
		document.title = `برچسب ${tagTitle || ''} | همراهتیم`;
		let description = document.querySelector('meta[name="description"]');
		if (description) {
			description.setAttribute('content', `برچسب ${tagTitle || ''}`);
		}
	}, [tagTitle]);

	function onReceiveTitle(title) {
		setTagTitle(title)
	}

	return (
		<>
			<Helmet>
				<title>برچسب | همراهتیم</title>
				<meta name="description" content="برچسب" />
			</Helmet>

			<div className="bg-[#F0F6FC] flex min-h-screen flex-col">
				<div className="flex flex-1 flex-col">
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? "w-[1200px]" : ""} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[24px] md:p-[32px]" />
					<div
						className={`${isDesktop ? "w-[1200px]" : "p-[10px]"} mx-auto flex flex-1 flex-col pb-4`}
					>
						<TagSection tagId={tagId} isDesktop={isDesktop} onReceiveTitle={onReceiveTitle} />
					</div>
				</div>
				<Footer isDesktop={isDesktop} activeButton={FooterButton.WORKSHOPS} />
			</div>
		</>
	)
}
